import { ReactNode } from 'react';
import { RouteTo } from '../../../types';
import {
  getStartUrlForProvider,
  OnTrackSignupConversion,
  OnTrackSignupIntent,
  SSOButton,
} from '../SSOButton';
import { FacebookLogo } from './FacebookLogo';

type FacebookSSOButtonProps = {
  children?: ReactNode;
  /** The URL to redirect to after auth is complete */
  next?: string;
  /** Callback to track signup conversions */
  onTrackSignupConversion?: OnTrackSignupConversion;
  /** Callback to track signup intent */
  onTrackSignupIntent?: OnTrackSignupIntent;
  /** Query params to be added to url */
  params?: Record<string, string | number | boolean>;
  /** Routing callback to integrate with router. Will use window.href.location directly when not specified */
  routeTo?: RouteTo;
};

export function FacebookSSOButton({
  children = 'Continue with Facebook',
  next,
  onTrackSignupConversion,
  onTrackSignupIntent,
  params = {},
  routeTo,
}: FacebookSSOButtonProps) {
  return (
    <SSOButton
      href={getStartUrlForProvider('facebook')}
      next={next}
      onTrackSignupConversion={onTrackSignupConversion}
      onTrackSignupIntent={onTrackSignupIntent}
      params={params}
      routeTo={routeTo}
      type="facebook-sso"
      icon={<FacebookLogo />}
    >
      {children}
    </SSOButton>
  );
}
